<template>
  <div class="informationRecord div-layout">
    <module-title title="通知栏消息记录" />
    <main>
      <BaseTable
        v-loading="listLoading"
        class="list-table"
        :columns="columns"
        :data="dataList"
        border
      />
      <pagination
        :total="pageObj.total"
        :page.sync="pageObj.currentPage"
        :limit.sync="pageObj.pageSize"
        @pagination="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </main>
  </div>
</template>

<script>

import { deskAdvertisingList } from '@/api/productOperation/mrDesk/informationRecord';
import { ColumnsIR } from '../store';

export default {
  data() {
    return {
      // 查询条件
      pageObj: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      //   表格
      listLoading: false,
      columns: ColumnsIR,
      dataList: []
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    // 获取数据
    getTableList() {
      this.listLoading = true;
      const { currentPage, pageSize } = this.pageObj;
      const params = {
        pageNum: currentPage,
        pageSize
      };
      deskAdvertisingList(params)
        .then((res) => {
          this.listLoading = false;
          const data = res.data;
          if (data) {
            this.dataList = data.list || [];
            this.pageObj.total = data.total || 0;
          }
        })
        .catch((error) => {
          this.listLoading = false;
          console.log(error);
        });
    },
    // pageSize 改变时会触发
    handleSizeChange(obj) {
      this.pageObj.currentPage = 1;
      this.pageObj.pageSize = obj.limit;
      this.getTableList();
    },
    // currentPage 改变时会触发
    handleCurrentChange(obj) {
      this.pageObj.currentPage = obj.page;
      this.pageObj.pageSize = obj.limit;
      this.getTableList();
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
